import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router";
import ArrowTip from "./img/arrow-tip.svg?react";
import "./style.scss";
import DOMPurify from "dompurify";

export default function SectionHeader({
  children,
  pageHeader = false,
  href = false,
  back = false,
  forward = false,
  blank = false,
  dangerouslySetInnerHTML = false,
}) {
  const navigate = useNavigate(-1);

  if (href) {
    return (
      <Link
        to={href}
        target={blank ? "_blank" : ""}
        rel={blank ? "noopener noreferrer" : undefined}
        className={`section-header-ultrainsider link`}
      >
        <h2>{children}</h2>
        {forward && <ArrowTip />}
      </Link>
    );
  }

  if (back && dangerouslySetInnerHTML) {
    return (
      <div
        onClick={() => navigate(-1)}
        className={`section-header-ultrainsider back`}
      >
        <h2 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(dangerouslySetInnerHTML)}} />
        {forward && <ArrowTip />}
      </div>
    );
  }

  if (back) {
    return (
      <div
        onClick={() => navigate(-1)}
        className={`section-header-ultrainsider back`}
      >
        <h2>{children}</h2>
        {forward && <ArrowTip />}
      </div>
    );
  }

  if (dangerouslySetInnerHTML) {
    return (
      <div
        className={`section-header-ultrainsider ${pageHeader ? "page-header" : ""}`}
      >
        <h2 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(dangerouslySetInnerHTML)}} />
        {forward && <ArrowTip />}
      </div>
    );
  }

  return (
    <div
      className={`section-header-ultrainsider ${pageHeader ? "page-header" : ""}`}
    >
      <h2>{children}</h2>
      {forward && <ArrowTip />}
    </div>
  );
}
